// extracted by mini-css-extract-plugin
export default {"verify":"styles_verify__3wXew","inlineButton":"styles_inlineButton__sOFUD","emailButton":"styles_emailButton__uNr34"};